<template>
  <div class="employeeInformation">
    <van-form
      label-width="120px"
      :show-error="false"
      :scroll-to-error="false"
      @failed="onFailed"
      @submit="onSubmit"
    >
      <div class="title">{{ $t.employee.title1 }}</div>
      <van-field :label="$t.employee.photo">
        <template #input>
          <van-uploader v-model="personalPhoto" :max-count="1" :after-read="afterRead1" />
        </template>
      </van-field>
      <van-field
        readonly
        clickable
        :value="form.EntryDate"
        :label="$t.employee.entryDate"
        :placeholder="$t.information.select"
        @click="onShowCalendar('showCalendar1', 0)"
      />
      <van-field
        v-model="form.EntryPosition"
        :label="$t.employee.position"
        :placeholder="$t.information.input"
      />
      <div class="title">{{ $t.employee.title2 }}</div>
      <van-field
        v-model="form.Surname"
        :label="$t.employee.surname"
        :name="$t.employee.surname"
        :placeholder="$t.information.input"
        required
        :rules="formRule"
      />
      <van-field
        v-model="form.PhoneNumber"
        :label="$t.employee.phoneNumber"
        :placeholder="$t.information.input"
      />
      <van-field
        v-model="form.IdentityCardNumber"
        :label="$t.employee.idCardNumber"
        :placeholder="$t.information.input"
      />
      <van-field :label="$t.employee.marital">
        <template #input>
          <van-radio-group v-model="form.MaritalState" direction="horizontal">
            <van-radio :name="1">{{ $t.employee.mOption1 }}</van-radio>
            <van-radio :name="2">{{ $t.employee.mOption2 }}</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <van-field
        v-model="form.CommunicationAddress"
        :label="$t.employee.address"
        :placeholder="$t.information.input"
        type="textarea"
        rows="5"
      />
      <van-field
        v-model="form.Nationality"
        :label="$t.employee.nationality"
        :placeholder="$t.information.input"
      />
      <van-field
        v-model="form.NativePlace"
        :label="$t.employee.nativePlace"
        :placeholder="$t.information.input"
      />
      <van-field :label="$t.employee.gender">
        <template #input>
          <van-radio-group v-model="form.Gender" direction="horizontal">
            <van-radio :name="1">{{ $t.employee.male }}</van-radio>
            <van-radio :name="2">{{ $t.employee.female }}</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <van-field
        readonly
        clickable
        :value="form.BirthDate"
        :label="$t.employee.birthDate"
        :placeholder="$t.information.select"
        @click="onShowCalendar('showCalendar2', 0)"
      />

      <div class="multi-table" v-if="form.EmergencyContactList">
        <van-field name="stepper" :label="$t.employee.title3">
          <template #input>
            <van-stepper
              :min="0"
              :value="form.EmergencyContactList.length"
              @minus="handleContactsDel"
              @plus="handleContactsAdd"
              :disable-input="true"
            />
          </template>
        </van-field>
        <div v-for="(item, index) in form.EmergencyContactList" :key="index">
          <div class="multi-table-header">
            <div class="multi-table-title"></div>
            <div class="multi-table-btn" @click="handleContactsDelByIndex(index)">
              <van-icon name="close" />
            </div>
          </div>
          <van-field
            v-model="item.ContactName"
            :label="$t.employee.contactName"
            :placeholder="$t.information.input"
          />
          <van-field
            v-model="item.ContactPhoneNumber"
            :label="$t.employee.contactPhone"
            :placeholder="$t.information.input"
          />
        </div>
      </div>

      <div class="multi-table" v-if="form.EducationList">
        <van-field name="stepper" :label="$t.employee.title4">
          <template #input>
            <van-stepper
              :min="0"
              :value="form.EducationList.length"
              @minus="handleEducationDel"
              @plus="handleEducationAdd"
              :disable-input="true"
            />
          </template>
        </van-field>
        <div v-for="(item, index) in form.EducationList" :key="index">
          <div class="multi-table-header">
            <div class="multi-table-title"></div>
            <div class="multi-table-btn" @click="handleEducationDelByIndex(index)">
              <van-icon name="close" />
            </div>
          </div>
          <van-field
            v-model="item.Education"
            :label="$t.employee.education"
            :placeholder="$t.information.input"
          />
          <van-field
            v-model="item.GraduateSchool"
            :label="$t.employee.school"
            :placeholder="$t.information.input"
          />
          <van-field
            readonly
            clickable
            :value="item.EnrollmentDate"
            :label="$t.employee.enrollmentDate"
            :placeholder="$t.information.select"
            @click="onShowCalendar('showCalendar3', index)"
          />
          <van-field
            readonly
            clickable
            :value="item.GraduationDate"
            :label="$t.employee.graduationDate"
            :placeholder="$t.information.select"
            @click="onShowCalendar('showCalendar4', index)"
          />
        </div>
      </div>

      <div class="multi-table" v-if="form.LanguageList">
        <van-field name="stepper" :label="$t.employee.title5">
          <template #input>
            <van-stepper
              :min="0"
              :value="form.LanguageList.length"
              @minus="handleLanguagesDel"
              @plus="handleLanguagesAdd"
              :disable-input="true"
            />
          </template>
        </van-field>
        <div v-for="(item, index) in form.LanguageList" :key="index">
          <div class="multi-table-header">
            <div class="multi-table-title"></div>
            <div class="multi-table-btn" @click="handleLanguagesDelByIndex(index)">
              <van-icon name="close" />
            </div>
          </div>
          <van-field
            v-model="item.Language"
            :label="$t.employee.languageName"
            :placeholder="$t.information.input"
          />
          <van-field :label="$t.employee.listen">
            <template #input>
              <van-radio-group v-model="item.Listen" direction="horizontal">
                <van-radio :name="1">{{ $t.employee.lOption1 }}</van-radio>
                <van-radio :name="2">{{ $t.employee.lOption2 }}</van-radio>
                <van-radio :name="3">{{ $t.employee.lOption3 }}</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field :label="$t.employee.say">
            <template #input>
              <van-radio-group v-model="item.Say" direction="horizontal">
                <van-radio :name="1">{{ $t.employee.lOption1 }}</van-radio>
                <van-radio :name="2">{{ $t.employee.lOption2 }}</van-radio>
                <van-radio :name="3">{{ $t.employee.lOption3 }}</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field :label="$t.employee.read">
            <template #input>
              <van-radio-group v-model="item.Read" direction="horizontal">
                <van-radio :name="1">{{ $t.employee.lOption1 }}</van-radio>
                <van-radio :name="2">{{ $t.employee.lOption2 }}</van-radio>
                <van-radio :name="3">{{ $t.employee.lOption3 }}</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field :label="$t.employee.write">
            <template #input>
              <van-radio-group v-model="item.Write" direction="horizontal">
                <van-radio :name="1">{{ $t.employee.lOption1 }}</van-radio>
                <van-radio :name="2">{{ $t.employee.lOption2 }}</van-radio>
                <van-radio :name="3">{{ $t.employee.lOption3 }}</van-radio>
              </van-radio-group>
            </template>
          </van-field>
        </div>
      </div>

      <div class="multi-table" v-if="form.TrainingCourseInfoList">
        <van-field name="stepper" :label="$t.employee.title6">
          <template #input>
            <van-stepper
              :min="0"
              :value="form.TrainingCourseInfoList.length"
              @minus="handleCourseDel"
              @plus="handleCourseAdd"
              :disable-input="true"
            />
          </template>
        </van-field>
        <div v-for="(item, index) in form.TrainingCourseInfoList" :key="index">
          <div class="multi-table-header">
            <div class="multi-table-title"></div>
            <div class="multi-table-btn" @click="handleCourseDelByIndex(index)">
              <van-icon name="close" />
            </div>
          </div>
          <van-field
            v-model="item.CourseName"
            :label="$t.employee.courseName"
            :placeholder="$t.information.input"
          />
          <van-field
            v-model="item.TrainingInstitutions"
            :label="$t.employee.institutions"
            :placeholder="$t.information.input"
          />
          <van-field
            readonly
            clickable
            :value="item.TrainingBeginDate"
            :label="$t.employee.beginDate"
            :placeholder="$t.information.select"
            @click="onShowCalendar('showCalendar5', index)"
          />
          <van-field
            readonly
            clickable
            :value="item.TrainingEndDate"
            :label="$t.employee.endDate"
            :placeholder="$t.information.select"
            @click="onShowCalendar('showCalendar6', index)"
          />
        </div>
      </div>

      <div class="multi-table" v-if="form.CertificateList">
        <van-field name="stepper" :label="$t.employee.title7">
          <template #input>
            <van-stepper
              :min="0"
              :value="form.CertificateList.length"
              @minus="handleCertificateDel"
              @plus="handleCertificateAdd"
              :disable-input="true"
            />
          </template>
        </van-field>
        <div v-for="(item, index) in form.CertificateList" :key="index">
          <div class="multi-table-header">
            <div class="multi-table-title"></div>
            <div class="multi-table-btn" @click="handleCertificateDelByIndex(index)">
              <van-icon name="close" />
            </div>
          </div>
          <van-field
            v-model="item.CertificateName"
            :label="$t.employee.certificate"
            :placeholder="$t.information.input"
          />
          <van-field
            readonly
            clickable
            :value="item.EffectiveBeginDate"
            :label="$t.employee.cBeginDate"
            :placeholder="$t.information.select"
            @click="onShowCalendar('showCalendar7', index)"
          />
          <van-field
            readonly
            clickable
            :value="item.EffectiveEndDate"
            :label="$t.employee.cEndDate"
            :placeholder="$t.information.select"
            @click="onShowCalendar('showCalendar8', index)"
          />
        </div>
      </div>

      <div class="multi-table" v-if="form.BankAccountList">
        <van-field name="stepper" :label="$t.employee.title8">
          <template #input>
            <van-stepper
              :min="0"
              :value="form.BankAccountList.length"
              @minus="handleBankDel"
              @plus="handleBankAdd"
              :disable-input="true"
            />
          </template>
        </van-field>
        <div v-for="(item, index) in form.BankAccountList" :key="index">
          <div class="multi-table-header">
            <div class="multi-table-title"></div>
            <div class="multi-table-btn" @click="handleBankByIndex(index)">
              <van-icon name="close" />
            </div>
          </div>
          <van-field
            v-model="item.PayeeName"
            :label="$t.employee.payeeName"
            :placeholder="$t.information.input"
          />
          <van-field
            v-model="item.BankName"
            :label="$t.employee.bankName"
            :placeholder="$t.information.input"
          />
          <van-field
            v-model="item.BankAccount"
            :label="$t.employee.bankAccount"
            :placeholder="$t.information.input"
          />
        </div>
      </div>

      <div class="title">{{ $t.employee.title9 }}</div>

      <div
        class="multi-table"
        style="margin-top: 0px"
        v-if="form.IdentificationCardFileList"
      >
        <van-field name="stepper" :label="$t.employee.idCard">
          <template #input>
            <van-stepper
              :min="0"
              :value="form.IdentificationCardFileList.length"
              @minus="handleIdentificationDel"
              @plus="handleIdentificationAdd"
              :disable-input="true"
            />
          </template>
        </van-field>
        <div v-for="(item, index) in form.IdentificationCardFileList" :key="index">
          <div class="multi-table-header">
            <div class="multi-table-title"></div>
            <div class="multi-table-btn" @click="handleIdentificationDelByIndex(index)">
              <van-icon name="close" />
            </div>
          </div>
          <van-field :label="'No.' + (index + 1)">
            <template #input>
              <van-button
                @click="imagePreview(imgUrlFilter(item.FileAddress))"
                type="primary"
                size="small"
                style="vertical-align: top; margin: 10px 30px 10px 0px"
                v-if="item.FileAddress"
                >{{ $t.employee.view }}</van-button
              >
              <van-uploader :after-read="afterRead2" @click-upload="uploaderClick(index)">
                <van-image
                  :src="item.FileAddress && imgUrlFilter(item.FileAddress)"
                  width="50"
                  height="50"
                  fit="contain"
                  style="vertical-align: top"
                  v-if="item.FileAddress"
                ></van-image>
                <van-button
                  type="info"
                  size="small"
                  style="vertical-align: top; margin: 10px 30px 10px 0px"
                  v-else
                  >{{ $t.employee.upload }}</van-button
                >
              </van-uploader>
            </template>
          </van-field>
        </div>
      </div>

      <div class="multi-table" v-if="form.GraduationCertificateFileList">
        <van-field name="stepper" :label="$t.employee.graduationBook">
          <template #input>
            <van-stepper
              :min="0"
              :value="form.GraduationCertificateFileList.length"
              @minus="handleGraduationCertificateDel"
              @plus="handleGraduationCertificateAdd"
              :disable-input="true"
            />
          </template>
        </van-field>
        <div v-for="(item, index) in form.GraduationCertificateFileList" :key="index">
          <div class="multi-table-header">
            <div class="multi-table-title"></div>
            <div
              class="multi-table-btn"
              @click="handleGraduationCertificateDelByIndex(index)"
            >
              <van-icon name="close" />
            </div>
          </div>
          <van-field :label="'No.' + (index + 1)">
            <template #input>
              <van-button
                @click="imagePreview(imgUrlFilter(item.FileAddress))"
                type="primary"
                size="small"
                style="vertical-align: top; margin: 10px 30px 10px 0px"
                v-if="item.FileAddress"
                >{{ $t.employee.view }}</van-button
              >
              <van-uploader :after-read="afterRead3" @click-upload="uploaderClick(index)">
                <van-image
                  :src="item.FileAddress && imgUrlFilter(item.FileAddress)"
                  width="50"
                  height="50"
                  fit="contain"
                  style="vertical-align: top"
                  v-if="item.FileAddress"
                ></van-image>
                <van-button
                  type="info"
                  size="small"
                  style="vertical-align: top; margin: 10px 30px 10px 0px"
                  v-else
                  >{{ $t.employee.upload }}</van-button
                >
              </van-uploader>
            </template>
          </van-field>
        </div>
      </div>

      <div class="multi-table" v-if="form.ResignationCertificateFileList">
        <van-field name="stepper" :label="$t.employee.resignBook">
          <template #input>
            <van-stepper
              :min="0"
              :value="form.ResignationCertificateFileList.length"
              @minus="handleResignationCertificateDel"
              @plus="handleResignationCertificateAdd"
              :disable-input="true"
            />
          </template>
        </van-field>
        <div v-for="(item, index) in form.ResignationCertificateFileList" :key="index">
          <div class="multi-table-header">
            <div class="multi-table-title"></div>
            <div
              class="multi-table-btn"
              @click="handleResignationCertificateDelByIndex(index)"
            >
              <van-icon name="close" />
            </div>
          </div>
          <van-field :label="'No.' + (index + 1)">
            <template #input>
              <van-button
                @click="imagePreview(imgUrlFilter(item.FileAddress))"
                type="primary"
                size="small"
                style="vertical-align: top; margin: 10px 30px 10px 0px"
                v-if="item.FileAddress"
                >{{ $t.employee.view }}</van-button
              >
              <van-uploader :after-read="afterRead4" @click-upload="uploaderClick(index)">
                <van-image
                  :src="item.FileAddress && imgUrlFilter(item.FileAddress)"
                  width="50"
                  height="50"
                  fit="contain"
                  style="vertical-align: top"
                  v-if="item.FileAddress"
                ></van-image>
                <van-button
                  type="info"
                  size="small"
                  style="vertical-align: top; margin: 10px 30px 10px 0px"
                  v-else
                  >{{ $t.employee.upload }}</van-button
                >
              </van-uploader>
            </template>
          </van-field>
        </div>
      </div>

      <div class="multi-table" v-if="form.ResumeFileList">
        <van-field name="stepper" :label="$t.employee.resume">
          <template #input>
            <van-stepper
              :min="0"
              :value="form.ResumeFileList.length"
              @minus="handleResumeFileDel"
              @plus="handleResumeFileAdd"
              :disable-input="true"
            />
          </template>
        </van-field>
        <div v-for="(item, index) in form.ResumeFileList" :key="index">
          <div class="multi-table-header">
            <div class="multi-table-title"></div>
            <div class="multi-table-btn" @click="handleResumeFileDelByIndex(index)">
              <van-icon name="close" />
            </div>
          </div>
          <van-field :label="'No.' + (index + 1)">
            <template #input>
              <van-button
                @click="imagePreview(imgUrlFilter(item.FileAddress))"
                type="primary"
                size="small"
                style="vertical-align: top; margin: 10px 30px 10px 0px"
                v-if="item.FileAddress"
                >{{ $t.employee.view }}</van-button
              >
              <van-uploader :after-read="afterRead5" @click-upload="uploaderClick(index)">
                <van-image
                  :src="item.FileAddress && imgUrlFilter(item.FileAddress)"
                  width="50"
                  height="50"
                  fit="contain"
                  style="vertical-align: top"
                  v-if="item.FileAddress"
                ></van-image>
                <van-button
                  type="info"
                  size="small"
                  style="vertical-align: top; margin: 10px 30px 10px 0px"
                  v-else
                  >{{ $t.employee.upload }}</van-button
                >
              </van-uploader>
            </template>
          </van-field>
        </div>
      </div>

      <div class="title">{{ $t.employee.sourceTitle }}</div>
      <van-field
        v-model="contents.ReceiveServer"
        :label="$t.employee.receivingServer"
        disabled
      />
      <van-field
        v-model="contents.ReceivePort"
        :label="$t.employee.receivePort"
        disabled
      />
      <van-field v-model="contents.SendServer" :label="$t.employee.sendServer" disabled />
      <van-field v-model="contents.SendPort" :label="$t.employee.sendPort" disabled />

      <div class="multi-table" v-if="contents.ResourceAllocationList">
        <van-field name="stepper" :label="$t.employee.allocatingResource">
          <template #input>
            <van-stepper
              :min="0"
              :value="contents.ResourceAllocationList.length"
              :disabled="true"
            />
          </template>
        </van-field>
        <div v-for="(item, index) in contents.ResourceAllocationList" :key="index">
          <div class="multi-table-header">
            <div class="multi-table-title">No.{{ index + 1 }}</div>
          </div>
          <van-field
            :value="
              item.AssetType == 1 ? $t.employee.fixedAssets : $t.employee.digitalAssets
            "
            :label="$t.employee.assetType"
            disabled
          />
          <van-field v-model="item.AssetName" :label="$t.employee.className" disabled />
          <van-field
            v-model="item.ProductName"
            v-if="item.AssetType == 1"
            :label="$t.employee.goodsName"
            disabled
          />
          <van-field
            v-model="item.AccountNumber"
            v-if="item.AssetType == 2"
            :label="$t.employee.accountNumber"
            disabled
          />
        </div>
      </div>

      <div class="multi-table" v-if="contents.ResourceAllocationFileList1">
        <van-field name="stepper" :label="$t.employee.welcomeLetter">
          <template #input>
            <van-stepper
              :min="0"
              :value="contents.ResourceAllocationFileList1.length"
              :disabled="true"
            />
          </template>
        </van-field>
        <div v-for="(item, index) in contents.ResourceAllocationFileList1" :key="index">
          <div class="multi-table-header">
            <div class="multi-table-title">No.{{ index + 1 }}</div>
          </div>
          <van-field :label="$t.employee.photo">
            <template #input>
              <van-image
                width="80"
                height="80"
                fit="contain"
                @click="imagePreview(imgUrlFilter(item.FileAddress))"
                :src="imgUrlFilter(item.FileAddress)"
              />
            </template>
          </van-field>
        </div>
      </div>

      <div class="multi-table" v-if="contents.ResourceAllocationFileList2">
        <van-field name="stepper" :label="$t.employee.cardFront">
          <template #input>
            <van-stepper
              :min="0"
              :value="contents.ResourceAllocationFileList2.length"
              :disabled="true"
            />
          </template>
        </van-field>
        <div v-for="(item, index) in contents.ResourceAllocationFileList2" :key="index">
          <div class="multi-table-header">
            <div class="multi-table-title">No.{{ index + 1 }}</div>
          </div>
          <van-field :label="$t.employee.photo">
            <template #input>
              <van-image
                width="80"
                height="80"
                fit="contain"
                @click="imagePreview(imgUrlFilter(item.FileAddress))"
                :src="imgUrlFilter(item.FileAddress)"
              />
            </template>
          </van-field>
        </div>
      </div>

      <div class="multi-table" v-if="contents.ResourceAllocationFileList3">
        <van-field name="stepper" :label="$t.employee.cardBack">
          <template #input>
            <van-stepper
              :min="0"
              :value="contents.ResourceAllocationFileList3.length"
              :disabled="true"
            />
          </template>
        </van-field>
        <div v-for="(item, index) in contents.ResourceAllocationFileList3" :key="index">
          <div class="multi-table-header">
            <div class="multi-table-title">No.{{ index + 1 }}</div>
          </div>
          <van-field :label="$t.employee.photo">
            <template #input>
              <van-image
                width="80"
                height="80"
                fit="contain"
                @click="imagePreview(imgUrlFilter(item.FileAddress))"
                :src="imgUrlFilter(item.FileAddress)"
              />
            </template>
          </van-field>
        </div>
      </div>

      <div class="multi-table" v-if="contents.ResourceAllocationFileList4">
        <van-field name="stepper" :label="$t.employee.mailSignature">
          <template #input>
            <van-stepper
              :min="0"
              :value="contents.ResourceAllocationFileList4.length"
              :disabled="true"
            />
          </template>
        </van-field>
        <div v-for="(item, index) in contents.ResourceAllocationFileList4" :key="index">
          <div class="multi-table-header">
            <div class="multi-table-title">No.{{ index + 1 }}</div>
          </div>
          <van-field :label="$t.employee.photo">
            <template #input>
              <van-image
                width="80"
                height="80"
                fit="contain"
                @click="imagePreview(imgUrlFilter(item.FileAddress))"
                :src="imgUrlFilter(item.FileAddress)"
              />
            </template>
          </van-field>
        </div>
      </div>

      <div class="tool-bar">
        <van-button block type="info" native-type="submit">{{
          $t.information.submit
        }}</van-button>
      </div>

      <van-popup v-model="showCalendar1" position="bottom">
        <van-datetime-picker
          type="date"
          :title="$t.employee.entryDate"
          :formatter="formatter"
          :confirm-button-text="$t.information.confirmButtonText"
          :cancel-button-text="$t.information.cancelButtonText"
          @confirm="onConfirm($event, 'EntryDate')"
          @cancel="showCalendar1 = false"
          :min-date="currentDate"
          v-model="selectDate"
        />
      </van-popup>
      <van-popup v-model="showCalendar2" position="bottom">
        <van-datetime-picker
          type="date"
          :title="$t.employee.birthDate"
          :formatter="formatter"
          :confirm-button-text="$t.information.confirmButtonText"
          :cancel-button-text="$t.information.cancelButtonText"
          @confirm="onConfirm($event, 'BirthDate')"
          @cancel="showCalendar2 = false"
          :min-date="currentDate"
          v-model="selectDate"
        />
      </van-popup>
      <van-popup v-model="showCalendar3" position="bottom">
        <van-datetime-picker
          type="date"
          :title="$t.employee.enrollmentDate"
          :formatter="formatter"
          :confirm-button-text="$t.information.confirmButtonText"
          :cancel-button-text="$t.information.cancelButtonText"
          @confirm="onConfirm($event, 'EnrollmentDate')"
          @cancel="showCalendar3 = false"
          :min-date="currentDate"
          v-model="selectDate"
        />
      </van-popup>
      <van-popup v-model="showCalendar4" position="bottom">
        <van-datetime-picker
          type="date"
          :title="$t.employee.graduationDate"
          :formatter="formatter"
          :confirm-button-text="$t.information.confirmButtonText"
          :cancel-button-text="$t.information.cancelButtonText"
          @confirm="onConfirm($event, 'GraduationDate')"
          @cancel="showCalendar4 = false"
          :min-date="currentDate"
          v-model="selectDate"
        />
      </van-popup>
      <van-popup v-model="showCalendar5" position="bottom">
        <van-datetime-picker
          type="date"
          :title="$t.employee.beginDate"
          :formatter="formatter"
          :confirm-button-text="$t.information.confirmButtonText"
          :cancel-button-text="$t.information.cancelButtonText"
          @confirm="onConfirm($event, 'TrainingBeginDate')"
          @cancel="showCalendar5 = false"
          :min-date="currentDate"
          v-model="selectDate"
        />
      </van-popup>
      <van-popup v-model="showCalendar6" position="bottom">
        <van-datetime-picker
          type="date"
          :title="$t.employee.endDate"
          :formatter="formatter"
          :confirm-button-text="$t.information.confirmButtonText"
          :cancel-button-text="$t.information.cancelButtonText"
          @confirm="onConfirm($event, 'TrainingEndDate')"
          @cancel="showCalendar6 = false"
          :min-date="currentDate"
          v-model="selectDate"
        />
      </van-popup>
      <van-popup v-model="showCalendar7" position="bottom">
        <van-datetime-picker
          type="date"
          :title="$t.employee.cBeginDate"
          :formatter="formatter"
          :confirm-button-text="$t.information.confirmButtonText"
          :cancel-button-text="$t.information.cancelButtonText"
          @confirm="onConfirm($event, 'EffectiveBeginDate')"
          @cancel="showCalendar7 = false"
          :min-date="currentDate"
          v-model="selectDate"
        />
      </van-popup>
      <van-popup v-model="showCalendar8" position="bottom">
        <van-datetime-picker
          type="date"
          :title="$t.employee.cEndDate"
          :formatter="formatter"
          :confirm-button-text="$t.information.confirmButtonText"
          :cancel-button-text="$t.information.cancelButtonText"
          @confirm="onConfirm($event, 'EffectiveEndDate')"
          @cancel="showCalendar8 = false"
          :min-date="currentDate"
          v-model="selectDate"
        />
      </van-popup>
    </van-form>
  </div>
</template>
<script>
import Vue from "vue";
import {
  Form,
  Field,
  Button,
  Uploader,
  Icon,
  Image,
  Popup,
  DatetimePicker,
  RadioGroup,
  Radio,
  Stepper,
} from "vant";

Vue.use(Form)
  .use(Field)
  .use(Button)
  .use(Uploader)
  .use(Icon)
  .use(Image)
  .use(Popup)
  .use(DatetimePicker)
  .use(RadioGroup)
  .use(Radio)
  .use(Stepper);

export default {
  name: "employeeInformation",
  data() {
    return {
      form: {},
      formRule: [
        {
          required: true,
          message: this.$t.meta.require,
        },
      ],
      personalPhoto: [],
      showCalendar1: false, //入职日期
      showCalendar2: false, //出生日期
      showCalendar3: false, //紧急联系人
      showCalendar4: false, //学历
      showCalendar5: false, //培训开始日期
      showCalendar6: false, //培训结束日期
      showCalendar7: false, //有效开始日期
      showCalendar8: false, //有效结束日期
      calendarIndex: 0,
      filesIndex: 0,
      selectDate: new Date(),
      currentDate: "",
      contents: {
        ReceiveServer: "", //收件服务器
        ReceivePort: "", //收件端口
        SendServer: "", //发件服务器
        SendPort: "", //	发件端口
        ResourceAllocationList: [], //分配资源列表
        //分配资源文件列表
        ResourceAllocationFileList1: [],
        ResourceAllocationFileList2: [],
        ResourceAllocationFileList3: [],
        ResourceAllocationFileList4: [],
      },
    };
  },
  created() {
    this.loadEmployeeArchivesInfo();
  },
  methods: {
    handleResumeFileDelByIndex(index) {
      if (this.form.ResumeFileList.length > 0) {
        this.form.ResumeFileList.splice(index, 1);
      }
    },
    handleResumeFileDel() {
      if (this.form.ResumeFileList.length > 0) {
        this.form.ResumeFileList.pop();
      }
    },
    handleResumeFileAdd() {
      this.form.ResumeFileList.push({
        ArchivesType: 4,
        FileAddress: "",
      });
    },
    handleResignationCertificateDelByIndex(index) {
      if (this.form.ResignationCertificateFileList.length > 0) {
        this.form.ResignationCertificateFileList.splice(index, 1);
      }
    },
    handleResignationCertificateDel() {
      if (this.form.ResignationCertificateFileList.length > 0) {
        this.form.ResignationCertificateFileList.pop();
      }
    },
    handleResignationCertificateAdd() {
      this.form.ResignationCertificateFileList.push({
        ArchivesType: 3,
        FileAddress: "",
      });
    },
    handleGraduationCertificateDelByIndex(index) {
      if (this.form.GraduationCertificateFileList.length > 0) {
        this.form.GraduationCertificateFileList.splice(index, 1);
      }
    },
    handleGraduationCertificateDel() {
      if (this.form.GraduationCertificateFileList.length > 0) {
        this.form.GraduationCertificateFileList.pop();
      }
    },
    handleGraduationCertificateAdd() {
      this.form.GraduationCertificateFileList.push({
        ArchivesType: 2,
        FileAddress: "",
      });
    },
    handleIdentificationDelByIndex(index) {
      if (this.form.IdentificationCardFileList.length > 0) {
        this.form.IdentificationCardFileList.splice(index, 1);
      }
    },
    handleIdentificationDel() {
      if (this.form.IdentificationCardFileList.length > 0) {
        this.form.IdentificationCardFileList.pop();
      }
    },
    handleIdentificationAdd() {
      this.form.IdentificationCardFileList.push({
        ArchivesType: 1,
        FileAddress: "",
      });
    },
    handleBankByIndex(index) {
      if (this.form.BankAccountList.length > 0) {
        this.form.BankAccountList.splice(index, 1);
      }
    },
    handleBankDel() {
      if (this.form.BankAccountList.length > 0) {
        this.form.BankAccountList.pop();
      }
    },
    handleBankAdd() {
      this.form.BankAccountList.push({
        PayeeName: "", //收款人姓名
        BankName: "", //开户银行
        BankAccount: "", //银行账号
      });
    },
    handleCertificateDelByIndex(index) {
      if (this.form.CertificateList.length > 0) {
        this.form.CertificateList.splice(index, 1);
      }
    },
    handleCertificateDel() {
      if (this.form.CertificateList.length > 0) {
        this.form.CertificateList.pop();
      }
    },
    handleCertificateAdd() {
      this.form.CertificateList.push({
        CertificateName: "", //证书名称
        EffectiveBeginDate: "", //有效开始日期
        EffectiveEndDate: "", //有效结束日期
      });
    },
    handleCourseDelByIndex(index) {
      if (this.form.TrainingCourseInfoList.length > 0) {
        this.form.TrainingCourseInfoList.splice(index, 1);
      }
    },
    handleCourseDel() {
      if (this.form.TrainingCourseInfoList.length > 0) {
        this.form.TrainingCourseInfoList.pop();
      }
    },
    handleCourseAdd() {
      this.form.TrainingCourseInfoList.push({
        CourseName: "", //课程名称
        TrainingInstitutions: "", //培训机构
        TrainingBeginDate: "", //培训开始日期
        TrainingEndDate: "", //	培训结束日期
      });
    },
    handleLanguagesDelByIndex(index) {
      if (this.form.LanguageList.length > 0) {
        this.form.LanguageList.splice(index, 1);
      }
    },
    handleLanguagesDel() {
      if (this.form.LanguageList.length > 0) {
        this.form.LanguageList.pop();
      }
    },
    handleLanguagesAdd() {
      this.form.LanguageList.push({
        Language: "", //语言名称
        Listen: "", //听
        Say: "", //说
        Read: "", //读
        Write: "", //写
      });
    },
    handleEducationDelByIndex(index) {
      if (this.form.EducationList.length > 0) {
        this.form.EducationList.splice(index, 1);
      }
    },
    handleEducationDel() {
      if (this.form.EducationList.length > 0) {
        this.form.EducationList.pop();
      }
    },
    handleEducationAdd() {
      this.form.EducationList.push({
        Education: "", //学历
        GraduateSchool: "", //毕业院校
        EnrollmentDate: "", //入学日期
        GraduationDate: "", //毕业日期
      });
    },
    handleContactsDelByIndex(index) {
      if (this.form.EmergencyContactList.length > 0) {
        this.form.EmergencyContactList.splice(index, 1);
      }
    },
    handleContactsDel() {
      if (this.form.EmergencyContactList.length > 0) {
        this.form.EmergencyContactList.pop();
      }
    },
    handleContactsAdd() {
      this.form.EmergencyContactList.push({
        ContactName: "", //联系人姓名
        ContactPhoneNumber: "", //联系人手机号码
      });
    },
    onShowCalendar(param, idx) {
      var date = new Date();
      date.setTime(date.getTime() - 3600 * 1000 * 24 * 36500);
      this.currentDate = date;
      this[param] = true;
      this.calendarIndex = idx;
    },
    onConfirm(date, type) {
      var formatDate = (val) => {
        var time = new Date(val).toLocaleDateString();
        let [year, month, date] = time.split("/");
        if (month < 10) {
          month = "0" + month;
        }
        if (date < 10) {
          date = "0" + date;
        }
        return year + "-" + month + "-" + date;
      };
      if (type == "EntryDate") {
        this.form.EntryDate = formatDate(date);
        this.showCalendar1 = false;
      }
      if (type == "BirthDate") {
        this.form.BirthDate = formatDate(date);
        this.showCalendar2 = false;
      }
      if (type == "EnrollmentDate") {
        this.form.EducationList[this.calendarIndex].EnrollmentDate = formatDate(date);
        this.showCalendar3 = false;
      }
      if (type == "GraduationDate") {
        this.form.EducationList[this.calendarIndex].GraduationDate = formatDate(date);
        this.showCalendar4 = false;
      }
      if (type == "TrainingBeginDate") {
        this.form.TrainingCourseInfoList[
          this.calendarIndex
        ].TrainingBeginDate = formatDate(date);
        this.showCalendar5 = false;
      }
      if (type == "TrainingEndDate") {
        this.form.TrainingCourseInfoList[this.calendarIndex].TrainingEndDate = formatDate(
          date
        );
        this.showCalendar6 = false;
      }
      if (type == "EffectiveBeginDate") {
        this.form.CertificateList[this.calendarIndex].EffectiveBeginDate = formatDate(
          date
        );
        this.showCalendar7 = false;
      }
      if (type == "EffectiveEndDate") {
        this.form.CertificateList[this.calendarIndex].EffectiveEndDate = formatDate(date);
        this.showCalendar8 = false;
      }
    },
    formatter(type, val) {
      if (type === "year") {
        return val + this.$t.meta.year;
      }
      if (type === "month") {
        return val + this.$t.meta.month;
      }
      if (type === "day") {
        return val + this.$t.meta.day;
      }
      return val;
    },
    imgUrlFilter(value) {
      return this.$api.formatImageUrl(value);
    },
    imagePreview(images) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.picturePreview, {
        pictureList: [images],
        startPosition: 0,
      });
    },
    loadEmployeeArchivesInfo() {
      this.$commonMethod.showLoading();
      var param = {};
      this.$api.businessLogistics
        .loadEmployeeArchivesInfo(param)
        .then((res) => {
          this.form = res.data;
          if (this.form.PersonalPhoto) {
            this.personalPhoto.push({
              url: this.imgUrlFilter(this.form.PersonalPhoto),
            });
          }
          //企业分配资源
          var resource = res.data.ResourceAllocation;
          var email = res.data.ResourceAllocation.EmailSetting;

          if (email) {
            this.contents.ReceiveServer = email.ReceiveServer ? email.ReceiveServer : "";
            this.contents.ReceivePort = email.ReceivePort ? email.ReceivePort : "";
            this.contents.SendServer = email.SendServer ? email.SendServer : "";
            this.contents.SendPort = email.SendPort ? email.SendPort : "";
          }

          this.contents.ResourceAllocationList = resource.ResourceAllocationList
            ? resource.ResourceAllocationList
            : [];

          this.contents.ResourceAllocationFileList1 = resource.ResourceAllocationFileList1
            ? resource.ResourceAllocationFileList1
            : [];

          this.contents.ResourceAllocationFileList2 = resource.ResourceAllocationFileList2
            ? resource.ResourceAllocationFileList2
            : [];

          this.contents.ResourceAllocationFileList3 = resource.ResourceAllocationFileList3
            ? resource.ResourceAllocationFileList3
            : [];

          this.contents.ResourceAllocationFileList4 = resource.ResourceAllocationFileList4
            ? resource.ResourceAllocationFileList4
            : [];
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    onSubmit() {
      this.$commonMethod.showLoading();
      var param = this.form;
      var filesList = [];
      filesList = filesList.concat(this.form.IdentificationCardFileList);
      filesList = filesList.concat(this.form.GraduationCertificateFileList);
      filesList = filesList.concat(this.form.ResignationCertificateFileList);
      filesList = filesList.concat(this.form.ResumeFileList);
      param.ArchivesFileList = filesList;
      this.$api.businessLogistics
        .saveEmployeeArchivesInfo(param)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.message,
            type: "success",
          });
          this.$commonEnv.commonAction(this.$commonEnv.actionType.pop);
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    onFailed(errorInfo) {
      if (errorInfo && errorInfo.errors.length > 0) {
        this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
          msg: errorInfo.errors[0].name + " " + errorInfo.errors[0].message,
        });
      }
    },
    uploaderClick(index) {
      this.filesIndex = index;
    },
    afterRead1(file) {
      this.$commonMethod.showLoading();
      var formData = new FormData();
      formData.append("file", file.file);
      this.$api.system
        .uploadImgFile(formData)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: this.$t.meta.uploadSuccess,
            type: "success",
          });
          this.form.PersonalPhoto = res.data;
          this.$commonMethod.hideLoading();
        })
        .catch(() => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: this.$t.meta.uploadFail,
          });
        });
    },
    afterRead2(file) {
      this.$commonMethod.showLoading();
      var formData = new FormData();
      formData.append("file", file.file);
      this.$api.system
        .uploadImgFile(formData)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: this.$t.meta.uploadSuccess,
            type: "success",
          });
          this.form.IdentificationCardFileList[this.filesIndex].FileAddress = res.data;
          this.$commonMethod.hideLoading();
        })
        .catch(() => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: this.$t.meta.uploadFail,
          });
        });
    },
    afterRead3(file) {
      this.$commonMethod.showLoading();
      var formData = new FormData();
      formData.append("file", file.file);
      this.$api.system
        .uploadImgFile(formData)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: this.$t.meta.uploadSuccess,
            type: "success",
          });
          this.form.GraduationCertificateFileList[this.filesIndex].FileAddress = res.data;
          this.$commonMethod.hideLoading();
        })
        .catch(() => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: this.$t.meta.uploadFail,
          });
        });
    },
    afterRead4(file) {
      this.$commonMethod.showLoading();
      var formData = new FormData();
      formData.append("file", file.file);
      this.$api.system
        .uploadImgFile(formData)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: this.$t.meta.uploadSuccess,
            type: "success",
          });
          this.form.ResignationCertificateFileList[this.filesIndex].FileAddress =
            res.data;
          this.$commonMethod.hideLoading();
        })
        .catch(() => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: this.$t.meta.uploadFail,
          });
        });
    },
    afterRead5(file) {
      this.$commonMethod.showLoading();
      var formData = new FormData();
      formData.append("file", file.file);
      this.$api.system
        .uploadImgFile(formData)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: this.$t.meta.uploadSuccess,
            type: "success",
          });
          this.form.ResumeFileList[this.filesIndex].FileAddress = res.data;
          this.$commonMethod.hideLoading();
        })
        .catch(() => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: this.$t.meta.uploadFail,
          });
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.employeeInformation {
  ::v-deep .van-field--disabled {
    .van-field__label,
    .van-field__control {
      color: #999 !important;
      -webkit-text-fill-color: #999 !important;
    }
  }
  .van-cell {
    border-bottom: 1px solid #ebedf0;
  }
  .van-cell::after {
    border: none !important;
  }
  .van-radio {
    font-size: 14px;
    ::v-deep .van-radio__label {
      color: #646566;
    }
  }
  .multi-table {
    .multi-table-header {
      padding: 10px 15px;
      .multi-table-title {
        font-size: 14px;
        color: #999;
        display: inline-block;
        vertical-align: middle;
      }
      .multi-table-btn {
        font-size: 20px;
        color: #000;
        width: 100%;
        display: inline-block;
        text-align: right;
        vertical-align: middle;
      }
    }
  }
  .tool-bar {
    box-sizing: border-box;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    background-color: white;
    z-index: 100;
    justify-content: space-between;
    padding-bottom: env(safe-area-inset-bottom);
    .van-button {
      border-radius: 0px;
    }
  }
}
</style>
